<!--
  @component

  /*                             */

  ```html
  <oc-badge-v1 size="100" variant="primary">1</oc-badge-v1>
  ```
  @slot required `default` content of the badge
-->
<svelte:options
  customElement={{
    tag: "oc-badge-v1",
    shadow: "none",
    /*                                                         */
    /*         */
    extend: (CustomElementConstructor) =>
      class extends CustomElementConstructor {
        constructor() {
          super();
          this.host = this;
          this.attachShadow({ mode: "open", delegatesFocus: true });
        }
      },
    props: {
      size: { type: "String", reflect: true },
      variant: { type: "String", reflect: true },
    },
  }}
/>

<script lang="ts">
  import { onMount } from "svelte";

  /**
 *
 */
  export let variant: "primary" | "secondary" | "success" = "primary";

  export let size: "50" | "100" = "100";

  /**
 *
 */
  export let host: HTMLElement;

  onMount(() => {
    host.role = "status";
  });
</script>

<div class="badge">
  {#if size === "100"}
    {#if variant === "success"}
      <oc-icon-v1 size="50" color="currentColor" type="check" />
    {:else}
      <slot />
    {/if}
  {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";
  @use "../../../common/scss/focus.scss";
  @use "BadgeV1.config" as config;

  :host {
    @include config.oc-badge;
    color: tokens.$oc-component-badge-100-text-color;
    text-align: center;
    outline-color: tokens.$oc-component-badge-border-color;
  }

  :host([size="100"]) {
    @include config.oc-badge-100;
    border-radius: 8px; /*                                                          */
  }
  :host([size="100"][variant="primary"]) {
    background-color: tokens.$oc-component-badge-primary-background-color;
  }

  :host([size="100"][variant="secondary"]) {
    background-color: tokens.$oc-component-badge-secondary-background-color;
  }

  :host([variant="success"]) {
    @include config.oc-badge-100-success;
    background-color: tokens.$oc-component-badge-success-background-color;
  }

  :host([size="50"]) {
    @include config.oc-badge-50;
    border-radius: 50%;
    background-color: tokens.$oc-component-badge-primary-background-color;
  }
</style>
